export const isUndefined = (value: any): value is undefined => typeof value === 'undefined';

export const isNull = (value: any): value is null => value === null;

export const isNullOrUndefined = (value: any): value is null | undefined => isNull(value) || isUndefined(value);
